import type SlSelect from '@shoelace-style/shoelace/dist/components/select/select.js';

export function initEventCategoryFilter(): void {
    const selectEl = document.getElementById('events-categories-select');
    if (!selectEl) return;

    let programmatic = false;
    let prevValues: string[] = [];
    let debounceTimer: ReturnType<typeof setTimeout> | null = null;

    function setValueProgrammatically(sl: SlSelect, vals: string[]): void {
        programmatic = true;
        (sl as unknown as {value: string[]}).value = vals;
        programmatic = false;
    }

    function navigate(identifiers: string[]): void {
        const url = new URL(window.location.href);
        url.hash = 'events-filter';
        url.searchParams.delete('page');
        if (identifiers.length > 0) {
            url.searchParams.set('categories', identifiers.join(','));
        } else {
            url.searchParams.delete('categories');
        }
        window.location.href = url.toString();
    }

    function syncAllClass(sl: SlSelect): void {
        const active = ((sl as unknown as {value: string[]}).value ?? []).filter(v => v !== '');
        selectEl!.classList.toggle('sl-events-all-shown', active.length === 0);
    }

    customElements.whenDefined('sl-select').then(() => {
        const sl = selectEl as unknown as SlSelect;

        const urlParam = new URLSearchParams(window.location.search).get('categories') ?? '';
        const activeIds = urlParam.split(',').map(v => v.trim()).filter(v => v !== '');
        if (activeIds.length > 0) {
            setValueProgrammatically(sl, activeIds);
            prevValues = [...activeIds];
        } else {
            setValueProgrammatically(sl, ['']);
            prevValues = [''];
        }
        syncAllClass(sl);

        selectEl!.addEventListener('sl-change', () => {
            if (programmatic) return;

            const current: string[] = (sl as unknown as {value: string[]}).value ?? [];
            const added = current.filter(v => !prevValues.includes(v));
            const realCategories = current.filter(v => v !== '');

            if (added.includes('') || current.length === 0) {
                setValueProgrammatically(sl, ['']);
                prevValues = [''];
                syncAllClass(sl);
                if (debounceTimer !== null) clearTimeout(debounceTimer);
                navigate([]);
                return;
            }

            if (current.includes('')) {
                setValueProgrammatically(sl, realCategories);
            }
            prevValues = realCategories;
            syncAllClass(sl);

            if (debounceTimer !== null) clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => navigate(realCategories), 500);
        });
    });
}
